var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 245 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.76,33.71a.76.76,0,0,1-.54-.23A20,20,0,0,1,.81,14.35a.72.72,0,0,1,1.39.4A18.63,18.63,0,0,0,6.29,32.51a.71.71,0,0,1-.53,1.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,40a19.9,19.9,0,0,1-9-2.13.74.74,0,0,1-.32-1,.72.72,0,0,1,1-.32A18.58,18.58,0,0,0,38.55,20a18.26,18.26,0,0,0-.79-5.36.73.73,0,0,1,1.39-.42A20,20,0,0,1,20,40Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9,8.74a.74.74,0,0,1-.45-.15.72.72,0,0,1-.12-1,20,20,0,0,1,30.58-.9.74.74,0,0,1-.06,1,.73.73,0,0,1-1-.06,18.57,18.57,0,0,0-28.37.84A.71.71,0,0,1,4.9,8.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,36.79A16.79,16.79,0,1,1,22,3.33a.72.72,0,0,1,.63.8.71.71,0,0,1-.8.63A15.91,15.91,0,0,0,20,4.66a15.34,15.34,0,0,0,0,30.68.72.72,0,0,1,.72.72A.73.73,0,0,1,20,36.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.69,35.33a.71.71,0,0,1-.65-.42.72.72,0,0,1,.35-1A15.34,15.34,0,0,0,27.66,6.71a.73.73,0,0,1-.26-1,.72.72,0,0,1,1-.26A16.79,16.79,0,0,1,27,35.27.85.85,0,0,1,26.69,35.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.76,29.66a.74.74,0,0,1-.52-.22A13.52,13.52,0,0,1,6.43,20a.72.72,0,0,1,1.44,0,12.06,12.06,0,0,0,3.41,8.43.72.72,0,0,1,0,1A.7.7,0,0,1,10.76,29.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,33.57a13.53,13.53,0,0,1-5.44-1.13.72.72,0,1,1,.58-1.32,12.14,12.14,0,0,0,14.17-3.35.72.72,0,0,1,1.11.92A13.5,13.5,0,0,1,20,33.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.28,24.53a.83.83,0,0,1-.22,0,.72.72,0,0,1-.47-.9A12.13,12.13,0,0,0,9.64,13.69a.72.72,0,1,1-1.23-.75A13.58,13.58,0,0,1,33.58,20,13.39,13.39,0,0,1,33,24,.72.72,0,0,1,32.28,24.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,10.36A9.64,9.64,0,1,0,29.64,20,9.65,9.65,0,0,0,20,10.36Zm1.72,10.9V23.8a1.72,1.72,0,0,1-3.44,0V21.26a3.61,3.61,0,1,1,3.44,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.84,9.26a8.54,8.54,0,0,1,6,2A6.83,6.83,0,0,1,69,16.58a6.94,6.94,0,0,1-2.22,5.36,8.49,8.49,0,0,1-6,2H54.23v8H50.6V9.26Zm0,11.39a4.76,4.76,0,0,0,3.32-1.11,3.79,3.79,0,0,0,1.22-3,3.8,3.8,0,0,0-1.22-2.92,4.76,4.76,0,0,0-3.32-1.11H54.23v8.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,15.09l-.23,3.39a9.68,9.68,0,0,0-1,0,5.71,5.71,0,0,0-4.74,2A8.63,8.63,0,0,0,76.43,26V32H72.91V15.16h3.52v3.59A7.15,7.15,0,0,1,82.84,15,3.84,3.84,0,0,1,84,15.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.77,8.55a2.08,2.08,0,0,1,.64,1.55,2.09,2.09,0,0,1-.62,1.56,2.21,2.21,0,0,1-1.61.61,2.26,2.26,0,0,1-1.63-.61,2,2,0,0,1-.64-1.56,2.11,2.11,0,0,1,.64-1.55,2.21,2.21,0,0,1,1.63-.65A2.13,2.13,0,0,1,90.77,8.55ZM87.41,32V15.16h3.53V32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.31,32h-3.76L94.33,15.12h3.83l5.29,12.64,5.28-12.64h3.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.62,32h-3.53V30a8.54,8.54,0,0,1-12-.08,8.71,8.71,0,0,1-2.46-6.39,8.72,8.72,0,0,1,2.47-6.37A8,8,0,0,1,122,14.68a8,8,0,0,1,6.1,2.41V15.16h3.53Zm-5.19-4.26a5.51,5.51,0,0,0,1.66-4.15,5.51,5.51,0,0,0-1.66-4.15,5.4,5.4,0,0,0-3.86-1.61,5.31,5.31,0,0,0-3.94,1.58,5.68,5.68,0,0,0-1.56,4.18,5.7,5.7,0,0,0,1.56,4.19,5.31,5.31,0,0,0,3.94,1.58A5.41,5.41,0,0,0,126.43,27.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.51,32H150v-1.9a8.27,8.27,0,0,1-6.1,2.37,8,8,0,0,1-5.87-2.5,8.72,8.72,0,0,1-2.47-6.38A8.68,8.68,0,0,1,138,17.19a8,8,0,0,1,5.87-2.51,8.12,8.12,0,0,1,6.1,2.41V7.56h3.55Zm-5.22-4.24A5.51,5.51,0,0,0,150,23.56a5.51,5.51,0,0,0-1.67-4.15,5.34,5.34,0,0,0-3.86-1.62,5.25,5.25,0,0,0-3.9,1.6A5.69,5.69,0,0,0,139,23.56a5.71,5.71,0,0,0,1.55,4.19,5.26,5.26,0,0,0,3.9,1.57A5.41,5.41,0,0,0,148.29,27.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.82,17.24a8.31,8.31,0,0,1,2.59,6.32,8.35,8.35,0,0,1-2.61,6.34,8.9,8.9,0,0,1-6.37,2.47A9,9,0,0,1,160,29.9a8.33,8.33,0,0,1-2.62-6.34A8.26,8.26,0,0,1,160,17.24a9.08,9.08,0,0,1,6.43-2.46A8.94,8.94,0,0,1,172.82,17.24Zm-2.49,10.47A5.55,5.55,0,0,0,172,23.56a5.59,5.59,0,0,0-9.51-4.15,5.57,5.57,0,0,0-1.64,4.15,5.56,5.56,0,0,0,1.64,4.15,5.59,5.59,0,0,0,7.85,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.46,32H185L175.11,9.26h4l7.59,17.79,7.59-17.79h4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.68,9.26a8.52,8.52,0,0,1,5.95,2,6.8,6.8,0,0,1,2.22,5.31,6.94,6.94,0,0,1-2.22,5.36,8.49,8.49,0,0,1-5.95,2h-6.61v8h-3.62V9.26Zm0,11.39A4.78,4.78,0,0,0,215,19.54a3.79,3.79,0,0,0,1.22-3A3.8,3.8,0,0,0,215,13.66a4.78,4.78,0,0,0-3.33-1.11h-6.61v8.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.19,32h-3.08L227.38,15.66V32h-3.63V9.25h3.09l13.69,16.58V9.25h3.66V32Z",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.af3fa02826dfc7e928d4abfdbad3aaa1.svg";
export { ForwardRef as ReactComponent };